<template>
  <section class="login">
    <div class="login-wrapper">
      <div class="fp-logo">
        <img src="@/assets/images/logo.png">
      </div>
      <div class="login-form-wrapper box">
        <p class="small-text uppercase-text">{{ $lang.messages.welcomeBack }}</p>
        <h1 class="title smaller-title uppercase-text">{{ $lang.messages.confirmPassword }}</h1>
        <hr class="horizontal-line">
        <form
          class="login-form"
          name="forgotPasswordConfirmForm"
          novalidate
          @submit.prevent
        >
          
          <!-- PASSWORD & REPEAT PASSWORD -->
          <f-p-input-new-repeat-pass
            :isRegister="false"
            :bluredProp="bluredProp"
            :passwordProp="passwordProp"
            :repeatPasswordProp="repeatPasswordProp"
            @updatePass="updatePass"
            @updateRepeatPass="updateRepeatPass"
            @clearOthersPass="clearOthers">
          </f-p-input-new-repeat-pass>

          <!-- CAPS LOCK HANDLER -->
          <f-p-is-caps-on :capsOnText="$lang.messages.capsIsOn" :isCapsOn="capsOn"></f-p-is-caps-on>
  
          <!-- SUBMIT -->
          <f-p-input-button
            :buttonText="$lang.messages.resetPassword"
            :loading="loading"
            @formSubmit="onForgotPasswordConfirmFormSubmitted">
          </f-p-input-button>
          
        </form>
        
        <hr class="horizontal-line">
        
        <f-p-input-footer
          :regLabel="$lang.messages.ifYouHaveAccount"
          :leadsTo="'Login'"
          :regDesc="$lang.messages.loginHere">
        </f-p-input-footer>
        
      </div>
      
      <f-p-copyright
        :copLabel="$lang.messages.copyright"
        :copDesc="$lang.messages.familipay">
      </f-p-copyright>
      
    </div>
    
    <div class="footer">
      <img src="@/assets/images/login_illustration.png" class="login-illustration">
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import { FORGOT_PASSWORD_CONFIRM } from "@/store/action.types";
import { isCapsOn } from "@/mixins/isCapsOn";
import { showHidePassword } from "@/mixins/showHidePassword";
import FPInputFooter from "@/components/common/inputs/FPInputFooter";
import FPCopyright from "@/components/common/inputs/FPCopyright";
import FPInputNewRepeatPass from "@/components/common/inputs/FPInputNewRepeatPass";
import FPInputButton from "@/components/common/inputs/FPInputButton";
import FPIsCapsOn from "@/components/common/inputs/FPIsCapsOn";

export default {
  name: "resetConfirm",
  components: {
    'f-p-input-footer': FPInputFooter,
    'f-p-copyright': FPCopyright,
    'f-p-input-new-repeat-pass': FPInputNewRepeatPass,
    'f-p-input-button': FPInputButton,
    'f-p-is-caps-on': FPIsCapsOn
  },
  mixins: [
    isCapsOn,
    showHidePassword
  ],
  props: {
    bluredProp: {
      type: String,
      required: true
    },
    passwordProp: {
      type: String,
      required: true
    },
    repeatPasswordProp: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    capsOn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      token: "",
      formSubmitted: false
    };
  },
  mounted() {
    this.token =  this.$route.query.token;
  },
  methods: {
    ...mapActions({
      passwordResetConfirmAction: FORGOT_PASSWORD_CONFIRM
    }),
    onForgotPasswordConfirmFormSubmitted() {
      // On form submit remove the error toolip, but leave the error on input field
      this.$emit('clearInputs');
      
      this.$validator.validateAll().then(result => {
        this.formSubmitted = true
        this.setMarginTooltip()
        if (result) {
          // On form submit show the loading spinner
          this.$emit('isLoading', true);
          
          this.passwordResetConfirmAction({
            password: this.passwordProp,
            confirmPassword: this.repeatPasswordProp,
            token: this.token
          })
          .then(() => {
            this.serverErrors = false;
            this.formSubmitted = false;
            this.$snotify.success(this.$lang.messages.sn_forgetPassConfirm, 'SUCCESS');
            // On form submit after response remove the loading spinner
            this.$emit('isLoading', false);
            this.$router.push({ name: "Login" });
          })
          .catch(() => {
            // On form submit after any error in response remove the loading spinner
            this.$emit('isLoading', false);
            
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR')
          });
        }
      });
    },
    setMarginTooltip() {
      let errorTooltip = document.getElementsByClassName('error-tooltip')

      for (let item of errorTooltip) {
        let height = item.offsetHeight
        if (height >= 60) {
          item.style.marginTop = "-40%"
        } else {
          item.style.marginTop = "-85px"
        }
      }
    },
    // Listen to values inside FPInputNewPass, call a function
    // and update the prop parent (LandingLayout) is sending to FPInputNewPass
    updatePass (val) {
      this.$emit('updatePass', val)
    },
    // Listen to values inside FPInputRepeatPass, call a function
    // and update the prop parent (LandingLayout) is sending to FPInputRepeatPass
    updateRepeatPass (val) {
      this.$emit('updateRepeatPass', val)
    },
    // Clear input errors from children, and send value to LandingLayout
    clearOthers (val) {
      this.$emit('clearOthers', val)
    }
  }
};
</script>
